import { render, staticRenderFns } from "./roomList-news.vue?vue&type=template&id=3e8ffefc&scoped=true"
import script from "./roomList-news.vue?vue&type=script&lang=js"
export * from "./roomList-news.vue?vue&type=script&lang=js"
import style0 from "./roomList-news.vue?vue&type=style&index=0&id=3e8ffefc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8ffefc",
  null
  
)

export default component.exports